import React from 'react';
import { withSessionSsr, getPublicToken } from "../../../lib/sessionMiddleware";
import { getCanonicalPath } from "../../../lib/canonical";
import useHook from '../../../hooks/pages/productos/[pid]/useHook';
import styles from './styles.module.scss';
import {
  Navbar,
  Wrapper,
  TituloSeccion,
  SubtituloSeccion,
  Seccion,
  Footer,
  Loader,
  HeadTags,
  BtnFlotanteWhatsapp,
  CarouselDeFotos,
  Container,
  CarouselDeProductosV2,
  ControlesCarrito,
  Link,
  // ContenedorEnvios,
  // ContenedorEnvios2,
  ContenedorEnvios3,
}from '../../../components';
import {
  Button,
} from '@mui/material';
import SentimentSatisfiedAltIcon from '@mui/icons-material/SentimentSatisfiedAlt';
import ShoppingCartOutlinedIcon from '@mui/icons-material/ShoppingCartOutlined';
import {currency} from '../../../utils/utils';
import {DESCUENTO_MAYORISTA} from '../../../utils/mayorista';
import MarkdownView from 'react-showdown';
import colors from '../../../styles/themes/variables.module.scss';

const ItemProductPage = (props)=>{

  const producto = props.pageProps.producto[0];
  const relacionados = props.pageProps.relacionados?.filter(p => p.id !== producto.id);
  const tematica = producto.attributes?.tematica?.data;

  const discount = DESCUENTO_MAYORISTA;

  const {
    mobile,
    showCartButton,
    esMayorista,
    cantidadEnCarrito,
    handleAgregar,
  } = useHook({producto});
    
  const schema = {
    "@context": "https://schema.org",
    "@type": "Product",
    "@id": `${process.env.NEXT_PUBLIC_URL_FRONTEND}/productos/${producto.attributes.slug}#product`,
    "name": producto.attributes.nombre,
    "description": producto.attributes.descripcionCorta,
    "image": producto.attributes.fotos?.data?.map(
      f => f.attributes.url
    ),
    "sku": producto.id,
    "brand": {
      "@type": "Brand",
      "name": "We Celebrate!"
    },
    "offers": {
      "@type": "Offer",
      "url": `${process.env.NEXT_PUBLIC_URL_FRONTEND}/productos/${producto.attributes.slug}`,
      "priceCurrency": "ARS",
      "price": producto.attributes.precioFinal,
      "availability": "https://schema.org/InStock",
      "itemCondition": "https://schema.org/NewCondition",
      "shippingDetails": {
        "@type": "OfferShippingDetails",
        "shippingDestination": {
          "@type": "DefinedRegion",
          "addressCountry": "AR"
        },
        "shippingRate": {
          "@type": "MonetaryAmount",
          "minValue": "10000",
          "currency": "ARS"
        },
        "deliveryTime": {
          "@type": "ShippingDeliveryTime",
          "handlingTime": {
            "@type": "QuantitativeValue",
            "minValue": 0,
            "maxValue": 1,
            "unitCode": "DAY"
          },
          "transitTime": {
            "@type": "QuantitativeValue",
            "minValue": 1,
            "maxValue": 1,
            "unitCode": "DAY"
          }
        }
      },
      "hasMerchantReturnPolicy": {
        "@type": "MerchantReturnPolicy",
        "applicableCountry": "AR",
        "returnPolicyCategory": "https://schema.org/MerchantReturnNotPermitted"
      }
    }
  };

  const breadcrumbItems = [
    {
      "@type": "ListItem",
      "position": 1,
      "name": "Inicio",
      "item": process.env.NEXT_PUBLIC_URL_FRONTEND
    },
    ...(tematica ? [{
      "@type": "ListItem",
      "position": 2,
      "name": tematica.attributes.nombre,
      "item": `${process.env.NEXT_PUBLIC_URL_FRONTEND}/tienda?tematica=${tematica.attributes.slug}`
    }] : []),
    {
      "@type": "ListItem",
      "position": tematica ? 3 : 2,
      "name": producto.attributes.nombre,
      "item": `${process.env.NEXT_PUBLIC_URL_FRONTEND}/productos/${producto.attributes.slug}`
    }
  ];

  const breadcrumbSchema = {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    "itemListElement": breadcrumbItems
  };

  const breadcrumbUI = [
    { label: "Inicio", href: "/" },
    ...(tematica ? [{ label: tematica.attributes.nombre, href: `/tienda?tematica=${tematica.attributes.slug}` }] : []),
    { label: producto.attributes.nombre },
  ];

  return(<>

    <HeadTags
      title={producto.attributes.nombre}
      description={producto.attributes.descripcionCorta}
      path={props.pageProps.pathname}
      schema={[schema, breadcrumbSchema]}
    />

    <Navbar/>

    <Seccion padding="32px 20px 60px" paddingMobile="16px 16px 40px">
      <Wrapper>
        <Container width="1200">

          <nav className={styles.breadcrumb} aria-label="Breadcrumb">
            {breadcrumbUI.map((item, i) => (
              <span key={i}>
                {item.href ? <Link href={item.href}>{item.label}</Link> : <span>{item.label}</span>}
                {i < breadcrumbUI.length - 1 && <span className={styles.separador}>/</span>}
              </span>
            ))}
          </nav>

          <div className={styles.layout}>
            <div className={styles.areaTitulo}>
              <TituloSeccion color={colors.secondary}>{producto.attributes.nombre}</TituloSeccion>
            </div>

            <div className={styles.areaGaleria}>
              <CarouselDeFotos
                data={producto.attributes.fotos?.data}
                badge={producto.attributes?.destacado ? "¡Novedad!" : undefined}
              />
            </div>

            <div className={styles.areaInfo}>
              <div className={styles.etiquetas}>
                {producto.attributes.tipo.data?.attributes.nombre &&
                  <span className={styles.etiqueta}>{producto.attributes.tipo.data.attributes.nombre}</span>
                }
                {producto.attributes.tematica.data?.attributes.nombre &&
                  <span className={styles.etiqueta}>{producto.attributes.tematica.data.attributes.nombre}</span>
                }
              </div>

              <br/>

              <MarkdownView
                markdown={producto.attributes.descripcionLarga}
                options={{ tables: true, emoji: true }}
                style={{
                  listStylePosition: "inside",
                  fontSize:"0.8rem",
                }}
              />

              <br/>

              <div className={styles.contenedorPrecios}>
                {esMayorista && <p className={styles.etiquetaMayorista}>Precio mayorista</p>}
                {esMayorista ? <>
                  <span className={styles.precio}>$ {currency(producto.attributes?.precioFinal * (1 - discount / 100))}</span>
                </>:<>
                  <span className={styles.precio}>$ {currency(producto.attributes?.precioFinal)}</span>
                  <span className={styles.precioTachado}>{producto.attributes?.precioTachado && `$${currency(producto.attributes?.precioTachado)}`}</span>
                </>}
              </div>

              <Container width={mobile ? "100%" : "260px"} style={{marginLeft: 0}}>
                {cantidadEnCarrito === 0 ? (
                  <Button
                    variant="contained"
                    color="otherPink2"
                    style={{ width: '100%', height: '40px' }}
                    startIcon={<ShoppingCartOutlinedIcon/>}
                    onClick={handleAgregar}
                  >
                    Agregar
                  </Button>
                ) : (
                  <ControlesCarrito producto={producto} leftAlign={true} mayorista={esMayorista}/>
                )}
              </Container>

              <br/>

              <ContenedorEnvios3/>

              {showCartButton && <>
                <br/>
                <div style={{width: mobile ? '100%' : 'fit-content'}}>
                  <Link href={esMayorista ? "/carrito-mayorista" : "/carrito"}>
                    <Button
                      color="primary"
                      variant="contained"
                      style={{
                        padding: "16px 36px",
                        display: "flex",
                        gap: "12px",
                        width: mobile ? "100%" : "240px"
                      }}
                    ><SentimentSatisfiedAltIcon/> Finalizar compra</Button>
                  </Link>
                </div>
              </>}

            </div>
          </div>
        </Container>

        {relacionados?.length > 0 &&
                    <>
                      <hr className={styles.divisor}/>
                      <SubtituloSeccion align="center">Productos relacionados</SubtituloSeccion>
                      <br/>
                      <CarouselDeProductosV2
                        data={relacionados}
                        // autoplay={{ delay: 3000 }}
                        spaceBetween={12}
                        slidesPerView={2}
                        slidesPerGroup={2}
                        breakpoints={{ 700: { slidesPerView: 4, slidesPerGroup: 4 } }}
                        loop={relacionados?.length > 4 ? true : false}
                        navigation={false}
                        // scrollbar={{ draggable: true }}
                        pagination={{ clickable: true }}
                      />
                    </>
        }

      </Wrapper>
    </Seccion>

    <br/><br/>
        
    <Footer/>
 
    <BtnFlotanteWhatsapp/>
  </>);
};

export default ItemProductPage;

export const getServerSideProps = withSessionSsr(
  async function getServerSideProps(ctx) {
  
    const { req } = ctx;

    const publicToken = await getPublicToken(req);
    const fetchProduct = async()=>{
      let body = {
        slug: ctx.query.pid
      };
      try{
        const result = await fetch(`${process.env.NEXT_PUBLIC_URL_FRONTEND}/api/productos/get-filtered`, {
          method: 'POST',
          headers: { 
            'Content-Type': 'application/json',
            'x-spiral-secret': process.env.SPIRAL_SECRET
          },
          body: JSON.stringify(body)
        });
        let data = await result.json();
        // console.log("producto", data.data)
        return (data?.data || []);
      }catch(err){
        console.log("e", err);
        return [];
      }     
    };

    const fetchRelated = async()=>{
      let body = {
        tematica: producto[0].attributes?.tematica?.data?.attributes?.slug,
      };
      try{
        const result = await fetch(`${process.env.NEXT_PUBLIC_URL_FRONTEND}/api/productos/get-filtered`, {
          method: 'POST',
          headers: { 
            'Content-Type': 'application/json',
            'x-spiral-secret': process.env.SPIRAL_SECRET
          },
          body: JSON.stringify(body)
        });
        let data = await result.json();
        // console.log("relacionados", data.data)
        return (data?.data || []);
      }catch(err){
        console.log("e", err);
        return [];
      }     
    };        

    let producto = await fetchProduct();

    if(producto?.length == 0){
      return {
        redirect: {
          destination: "/tienda",
          permanent: false, 
        },
      }; 
    }

    let relacionados = await fetchRelated();

    return {
      props: {
        pathname: getCanonicalPath(req),
        producto: producto,
        relacionados: relacionados,
      },
    };    
  
  },
);